/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Clock } from 'lucide-react';
import moment from 'moment-timezone';

const HOURS = Array.from({ length: 12 }, (_, i) => i + 1); // 1..12
const MINUTES = Array.from({ length: 12 }, (_, i) => i * 5); // 0,5,...,55

// Segmented time field (hour / minute / AM-PM) + clock icon — matches the
// PTO request / prototype time selector. Keeps the string API (`time` as
// "h:mm A", `setTime(string)`) so existing callers are unchanged.
function TimeSelector({ time, setTime }) {
  const m = time ? moment(time, ['h:mm A', 'HH:mm:ss', 'HH:mm']) : null;
  const valid = m && m.isValid();
  const h24 = valid ? m.hour() : 12;
  const minuteRaw = valid ? m.minute() : 0;
  const period = h24 >= 12 ? 'PM' : 'AM';
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  const minute = MINUTES.includes(minuteRaw) ? minuteRaw : (Math.round(minuteRaw / 5) * 5) % 60;

  const emit = (nh12, nm, np) => {
    let h = nh12 % 12;
    if (np === 'PM') h += 12;
    setTime(moment().hour(h).minute(nm).second(0)
      .format('h:mm A'));
  };

  const segCls = 'appearance-none bg-transparent border-0 text-sm text-ink-900 focus:outline-none tabular-nums font-medium cursor-pointer';
  const segStyle = { backgroundImage: 'none', paddingRight: 0 };

  return (
    <div className="flex items-center gap-1 h-10 px-3 border border-rule rounded-[8px] bg-white w-full" style={{ borderStyle: 'solid', boxSizing: 'border-box' }}>
      <select aria-label="Hour" value={h12} onChange={(e) => emit(Number(e.target.value), minute, period)} className={segCls} style={segStyle}>
        {HOURS.map((h) => <option key={h} value={h}>{String(h).padStart(2, '0')}</option>)}
      </select>
      <span className="text-ink-900 font-medium">:</span>
      <select aria-label="Minute" value={minute} onChange={(e) => emit(h12, Number(e.target.value), period)} className={segCls} style={segStyle}>
        {MINUTES.map((mm) => <option key={mm} value={mm}>{String(mm).padStart(2, '0')}</option>)}
      </select>
      <select aria-label="Period" value={period} onChange={(e) => emit(h12, minute, e.target.value)} className={segCls} style={segStyle}>
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
      <Clock size={16} className="text-ink-500 ml-auto flex-shrink-0" />
    </div>
  );
}

TimeSelector.propTypes = {
  time: PropTypes.string,
  setTime: PropTypes.func.isRequired,
};

TimeSelector.defaultProps = { time: '' };

export default TimeSelector;
